import { Link } from 'react-router-dom';
import { fonts } from './fonts/fonts';
import styled, { createGlobalStyle, css } from 'styled-components';

export const theme = {
  dark: {},
  light: {},
  colours: {
    Lotion: '#FBFBFB',
    BrightGray: '#EBEBEB',
    BrightGray2: '#7F7F99',
    BrightGray3: '#cdcdd7',
    DarkGray: '#1D1D1F',
    Gamboge: '#ED9E06',
    BlueViolet: '#422077',
    RichBlack: '#0E1405',
    Gainsboro: '#DED6EB',
    Keppel: '#3FA99E',
    white: '#FFFFFF',
    black: '#000000',
    black_2: '#161618',
    header: '#1A1A1A',
    blackText: '#303030',
    textColor: '#161618',
    Nickel: '#6E7176',
    error: '#B11E1E',
    error_2: '#C70A24',
    SpanishGray: '#9D9D9D',
    AntiFlashWhite: '#F2F2F2',
    TaupeGray: '#84888C',
    Cultured: '#F4F4F4',
    Danger: '#DC3545',
    Platinum: '#DFE2E5',
    Onyx: '#383634',
    DavysGrey: '#5A5A5A',
    PhilippineSilver: '#ACB2B5',
    Turquoise: '#41CEC0',
    Onyx_2: '#343638',
    red: '#F80707',
    red_2: '#CC0000',
    americanGreen: '#1EB147',
    gray: '#B8BBC2',
    gray2: '#666666',
    gray3: '#989898',
    gray4: '#7E7E7E',
    gray5: '#969696',
    AeroBlue: '#CEEFD7',
    LavenderGray: '#D6DDEB',
    warnning_color: '#FFF3CD',
    warnning_text_color: '#856404',
    success_color: 'rgba(76, 175, 80, 0.10)',
    success_text_color: '#4CAF50',
    mainBlue: '#0C58DB',
    lightBlue: 'rgba(12, 88, 219, 0.10)',
    silverChalice: '#ABABAB',
    LightSilver: '#D8D8D8',
    PermanentGeraniumLake: '#DC2D2D',
    success: '#4CAF50',
    DavyGrey: '#585858',
    RustyRed: '#DC354533',
    NewCar: '#0C58DB',
    lightGray: '#F1F1F1',
    lightGray2: '#EEEEEE',
    lightGray3: '#F5F5F5',
    newOutline: '#D4D4D4',
    successLight: '#C8E5D0',
    successLight2: '#8EB44D',
    errorLight: '#F8D7DA',
    blackBg: '#141414',
    black2: '#1d1d1f',
  },
  fonts: {
    ExtraBold: 'ExtraBold',
    SemiBold: 'SemiBold',
    Bold: 'Bold',
    Regular: 'Regular',
    Medium: 'Medium',
  },
  space_size: '8px',
  brekpoints: {
    smallMobile: '360px',
    tablet: '768px',
    bigTablet: '1024px',
    desketop: '1280px',
  },
  Snippets: {
    textOverflowHide: css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `,
  },
};

export const GlobalStyles = createGlobalStyle`
	${fonts}

	*{
		position: relative;
		padding: 0;
		margin: 0;
		direction: rtl;
		box-sizing: border-box;
		font-family: ${theme.fonts.Regular}, sans-serif !important;
    font-weight: 400;
		&:lang(en) {
			direction: ltr;
		}
	};
	.mantine-Select-wrapper{
		input{
		font-family: ${theme.fonts.Regular}, sans-serif !important;
		font-weight: 400;
	}
}


.list-select {
  /* Default scrollbar styling for non-Safari browsers */
  direction: rtl !important;
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #eaeaea;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(200, 200, 200);
    border-radius: 4px;
  }
  
  
  /* Hide scrollbar ONLY on Safari (including iOS Safari) */
  @supports (-webkit-hyphens:none) {
    ::-webkit-scrollbar {
      display: none;
      width: 0;
    }
    scrollbar-width: none;
  }
}

.mantine-Select-itemsWrapper {
    .clear-option {
      color: ${theme.colours.mainBlue} !important;
      border-top: 1px solid #e2e2e2 !important;
      margin-top: 4px !important;
      padding-top: 8px !important;
      font-size: 14px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      padding: 8px 12px !important;
      cursor: pointer !important;
      background-color: transparent !important;
      border: none !important;
      position: sticky !important;
      bottom: 0 !important;
      background-color: white !important;
      z-index: 1 !important;
    }
  }

.mantine-Select-input{
	text-overflow: ellipsis !important;
}

.mantine-Select-root .mantine-Select-rightSection {
	margin-inline-end: 8px !important;
}

.mantine-Drawer-header {
  padding: 16px;
  border-bottom: 1px solid ${theme.colours.newOutline};
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.mantine-Drawer-body {
  padding: 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

  .mantine-Drawer-title {
    font-size: 16px;
    font-weight: 400;
    width: 100% !important;
    margin: 0;
  .mantine-Drawer-close {
    position: static;
    margin: 0 !important;
    margin-left: 0 !important;
    order: -1;
    
    svg {
      margin: 0 !important;
      margin-left: 0 !important;
    }
  }
}

.react-select__control {
  box-shadow: none !important;
}

.react-select__option--is-selected {
  background-color: #1d1d1f !important;
  color: white;
}
.redirect-method-dropdown, .events-dropdown{
  right: 0 !important;
  position: absolute !important;
}

      .react-select__option--is-focused:not(.react-select__option--is-selected) {
		background-color: rgb(242, 242, 242) !important;
	}

html{
		overflow-x:hidden;
		::-webkit-scrollbar {
      width: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #7F7F99;
      border-radius: 4px;
    }
	}

.link-btn {
      color: ${theme.colours.mainBlue} !important;
      cursor: pointer;
    }

.mantine-Modal-inner{
	@media (max-width: 768px) {
				padding: 0;
               right:1px !important;
			}

		}

.container-select {
    position: absolute;
    top: 74px;
    background-color: white;
    display: flex;
    flex-direction: column;
    width: 176px;
    border-radius: 8px;
    z-index: 4;
	.btn-wrapper{
		padding: 8px 12px;
		border-bottom: 1px solid rgb(200,200,200);

	}
    p {
      font-size: 14px;
      cursor: pointer;
	  line-height:22px;
    }
	button{
		background-color: #EBEBEB;
		padding: 4px 8px;
		color: ${theme.colours.blackText};
		width: 100%;
		.mantine-Button-inner{
			align-items: center;
			justify-content: flex-start;
			gap:8px;
		}
&:hover{
	background-color: #EBEBEB;
}
	}
  }

  .events-container-select-wrapper {
	padding: 0 !important;
	border: none !important;
			.container-select {
				top: unset !important;
			}
		}
	html, body, #root, .App{
		min-height: 100vh;
		background-color: ${theme.colours.Cultured};
		@media (max-width: 768px) {
			/* min-height: calc(100vh - 80px); */
			min-height: unset;
       }
	}
	.Bold{
		font-family: ${theme.fonts.Bold} !important;
	}
	.ExtraBold{
		font-family: ${theme.fonts.ExtraBold} !important;
	}
.SemiBold{
		font-family: ${theme.fonts.SemiBold} !important;
	}
.Regular{
		font-family: ${theme.fonts.Regular} !important;
	}
.Medium{
		font-family: ${theme.fonts.Medium} !important;
	}
	.ErrorMessageStyle{
		color: ${theme.colours.error};
		font-size: 13px;
		font-family: ${theme.fonts.Medium};
		min-height: 25px;
		display: flex;
		align-items: flex-end;
		p{
			color: ${theme.colours.error} !important;
			font-size: 13px;
		}
	}
	.mantine-Modal-header{
		background-color: ${theme.colours.Cultured};
		justify-content: space-between;
		align-items: center;
		padding: ${theme.space_size} calc(${theme.space_size} * 2);
		border-bottom:1px solid ${theme.colours.gray};
		color: ${theme.colours.DavysGrey};
		font-family: ${theme.fonts.Medium};
		@media (max-width: 767px) {
      padding: 16px 30px !important;
    }
		>button{
			margin: 0;
		}
	}

	.mantine-Modal-content{
		border-radius: 16px;
		::-webkit-scrollbar {
      width: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #7F7F99;
      border-radius: 4px;
    }
		@media(max-width:550px){
			flex: unset !important;
		}

	}

	.hide-modal{
		display: none;
	}

	.phone-input-event{
			/* margin-top: -16px; */

	}

	.emptyTable table{
		border-bottom: 0 !important;
		border-right: 0 !important;
		border-left: 0 !important;
		tbody{
			tr{
				td{
					border: 0 !important;
					
				}
			}
		}
	}



	.success-modal{
		z-index: 1099;
	}

	.mantine-ColorPicker-wrapper{
		z-index: 2000 !important;
	}
	@media (min-width: 768px) {
    .large-screen {
      display: block;
    }
    .small-screen {
      display: none;
    }
  }
  @media (max-width: 767.5px) {
    .large-screen {
      display: none;
    }
    .small-screen {
      display: block;
      margin-top: 16px;
    }
	.small-screen.flex {
      display: flex;
      margin-top: 16px;
    }
  }

	.success-modal .mantine-Modal-content{
		@media(max-width:550px){
			padding-inline :10%;
			flex: unset !important;
		}

	}
	.mantine-Modal-content{
		@media(max-width:767px){
	    width:90%;

		}
		button{
			@media(max-width:767px){
				width:50% !important;

		}
		}
	}
	.success-modal{
		button{
			@media(max-width:767px){
				width:unset !important;

		}
		}
	}

	.Toastify__toast-theme--colored.Toastify__toast--success{
		background-color: white !important;
		color: ${theme.colours.blackText} !important;
		min-height:18px;
		font-size: 14px;
		padding: 0;
	}
	.Toastify__toast-container--top-right {
    top: 4em;
    right: 1em;
}

	.mantine-Menu-dropdown {
		button {
			&:lang(ar) {
				text-align: right;
			}
		}
	}
	 .listOptions-dropdwon {
		 min-width: 300px !important;
		 @media (max-width: 767px) {
			 min-width:150px !important;
		 }
		 /* @media (max-width: 500px) {
			&:lang(ar){
				left:25px !important;
			}
			&:lang(en){
				right:25px !important;
			}
		 } */

			.mantine-Select-separatorLabel {
    &::after {
      margin-right: 5px !important;
      margin-left: 0px !important;
    }
  }

  }
  .listOptions-events-dropdwon , .listOptions-clients-dropdwon {
    width: fit-content !important;
	max-width: 300px !important;
	@media (max-width: 767px) {
			 min-width:150px !important;
			 left:unset !important;
			 right:20px !important;
		 }
  }
  .appointment-status-options-dropdown {
	width: 100px !important;

	/* @media (max-width: 500px) {
		&:lang(ar){
			right: 25px !important;
		}
		&:lang(en){
			left: 25px !important;
		}
	} */
  }
  .status-options-dropdown {
      width: 100px !important;
	  /* @media (max-width: 500px) {
		&:lang(ar){
			right: 105px !important;
		}
		&:lang(en){
			left: 105px !important;
		}
	  } */
  }
  .condition-options-dropdown {
      width: 170px !important;
  }
  .sync-status-options-dropdown {
      width: 100px !important;
  }
  .question-options-dropdown {
	  @media (max-width: 767px) {
		&:lang(ar){
			right: 0 !important;
		}
		&:lang(en){
			left: 0 !important;
		}
	}
  }
  .clients-dropdown-dropdwon {
      width: 150px !important;
  }

  .mantine-ColorInput-dropdown {
    z-index: 9999 !important;
  }

  .mantine-DateInput-root {
    margin-top: 4px;
    .mantine-DateInput-wrapper {
    .mantine-DateInput-input {
      border-radius: 8px !important;
      text-align: right;

      ::placeholder {
       color: ${theme.colours.blackText};
       font-family: ${theme.fonts.Regular};

   }
    }
  }
  }

	.md-hidden{
		display: none;
		@media(min-width:992px){
			display: block;
		}
	}
	.lg-hidden{
		@media(min-width:992px){
			display: none;
		}
	}
	a{
		text-decoration: none;
	}
	.mantine-DateInput-calendarHeaderControl {
		&:lang(ar){
			transform: rotate(180deg) !important;
		}
	}

	/* Override Mantine DatePicker selected date background color - All possible selectors */
	.mantine-DatePicker-day[data-selected],
	.mantine-Calendar-day[data-selected],
	.mantine-Month-day[data-selected],
	.mantine-DateInput-day[data-selected],
	button[data-selected],
	.mantine-Calendar-cell button[data-selected],
	.mantine-Month-cell button[data-selected] {
		background-color: ${theme.colours.blackText} !important;
		color: white !important;
		border-color: ${theme.colours.blackText} !important;
	}

	.mantine-DatePicker-day[data-selected]:hover,
	.mantine-Calendar-day[data-selected]:hover,
	.mantine-Month-day[data-selected]:hover,
	.mantine-DateInput-day[data-selected]:hover,
	button[data-selected]:hover,
	.mantine-Calendar-cell button[data-selected]:hover,
	.mantine-Month-cell button[data-selected]:hover {
		background-color: ${theme.colours.blackText} !important;
		color: white !important;
		border-color: ${theme.colours.blackText} !important;
	}

	/* Ultra specific selectors with higher specificity */
	div[class*="mantine-Calendar"] button[data-selected],
	div[class*="mantine-DatePicker"] button[data-selected],
	div[class*="mantine-Month"] button[data-selected] {
		background-color: ${theme.colours.blackText} !important;
		color: white !important;
		border-color: ${theme.colours.blackText} !important;
	}

	/* Force override any blue colors */
	.mantine-Calendar button[aria-pressed="true"],
	.mantine-Month button[aria-pressed="true"],
	.mantine-DatePicker button[aria-pressed="true"] {
		background-color: ${theme.colours.blackText} !important;
		color: white !important;
		border-color: ${theme.colours.blackText} !important;
	}
	.noPaddingBorder{
		padding: 0 !important;
		border-radius: 8px;
	}
	.settings-wrapper{
	.module-wrapper{
		height: fit-content;
	}
	.settingLinks{
		width: 293px !important;
		max-width: 293px !important;
		padding: 0;
		@media (max-width : 1024px)  {
			max-width: unset !important;
			width: unset !important;

		}
	}
	.settingBody{
		max-width: 603px !important;
		width: 603px !important;
		padding-right:5px !important;
		padding-left:0 !important;
		@media (max-width : 1024px)  {
			max-width: unset !important;
			width: unset !important;
			padding-right:0px !important;

		}
	}

  }

  .custom-dropdown {
    width: 150px !important;
	/* @media (max-width: 500px) {
		&:lang(ar){
			left: 90px !important;
		}
		&:lang(en){
			right: 90px !important;
		}
	} */
  }
  .calendarHeader{
		@media(max-width:768px){
          margin-top: 0px !important;
		}
	}

  .bodyContainer #LayoutContainer{
	@media (min-width: 768px) {
    border-top-right-radius: 20px;
  }
  }

  /* Disabled Switch styles - gray instead of black */
  .mantine-Switch-input:disabled:checked + .mantine-Switch-track {
    background-color: #e0e0e0 !important;
    border-color: #b0b0b0 !important;
  }

  .mantine-Switch-input:disabled:checked + .mantine-Switch-track .mantine-Switch-thumb {
    background-color: #757575 !important;
    border: none !important;
  }

  .mantine-Switch-input:disabled + .mantine-Switch-track {
    cursor: not-allowed !important;
    opacity: 0.7 !important;
  }

  .mantine-Switch-input:disabled ~ .mantine-Switch-labelWrapper .mantine-Switch-label {
    color: #888888 !important;
    opacity: 0.8 !important;
    cursor: not-allowed !important;
  }

  .mantine-Switch-input:disabled ~ .mantine-Switch-labelWrapper .mantine-Switch-description {
    color: #888888 !important;
    opacity: 0.8 !important;
  }

  /* Disabled cursor for entire switch body */
  .mantine-Switch-body:has(input:disabled),
  .mantine-Switch-root:has(input:disabled) {
    cursor: not-allowed !important;
  }

  .mantine-Switch-body:has(input:disabled) * {
    cursor: not-allowed !important;
  }

  /* Disabled Checkbox styles - darker gray and white checkmark */
  /* Multiple selectors to ensure it catches all cases */
  .mantine-Checkbox-input:disabled:checked,
  input[type="checkbox"].mantine-Checkbox-input:disabled:checked,
  .mantine-Checkbox-inner input:disabled:checked {
    background-color: #757575 !important;
    border-color: #9e9e9e !important;
    opacity: 0.7 !important;
    cursor: not-allowed !important;
  }

  /* White checkmark icon for disabled checked checkboxes */
  .mantine-Checkbox-input:disabled:checked + .mantine-Checkbox-icon,
  .mantine-Checkbox-inner input:disabled:checked ~ .mantine-Checkbox-icon {
    color: #ffffff !important;
  }

  .mantine-Checkbox-input:disabled,
  input[type="checkbox"].mantine-Checkbox-input:disabled {
    cursor: not-allowed !important;
    opacity: 0.7 !important;
  }

  .mantine-Checkbox-input:disabled ~ .mantine-Checkbox-label,
  .mantine-Checkbox-body input:disabled ~ label {
    color: #888888 !important;
    opacity: 0.8 !important;
    cursor: not-allowed !important;
  }

  /* Disabled cursor for entire checkbox container */
  .mantine-Checkbox-body:has(input:disabled),
  .mantine-Checkbox-root:has(input:disabled) {
    cursor: not-allowed !important;
  }

  .mantine-Checkbox-body:has(input:disabled) * {
    cursor: not-allowed !important;
  }
`;

export const ViewDetails = styled(Link)`
  color: ${theme.colours.gray2};
  background-color: ${theme.colours.Cultured};
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
`;
